import React from "react";
import styles from "./DBListItem.module.scss";
import { getDefaultImage } from "../../utils/GeneralUtils";
import VerificationIcon from "../VerificationIcon";
import SonicLink from "../routing/SonicLink";

type Props = {
  to: string;
  name?: string;
  tags?: string[];
  img_src?: string;
  logo_src?: string;
  team_color?: string;
  isStudent?: boolean;
  verified?: boolean;
};

const DBListItem: React.FC<Props> = (props) => {
  const { name, tags, to, img_src, logo_src, team_color, isStudent, verified } =
    props;

  return (
    <article className={styles["c-DBlist-item"]}>
      <SonicLink to={to} className={styles["c-DBlist-item__link"]}>
        <div className={styles["c-DBlist-item__img-box"]}>
          <div
            className={styles["c-DBlist-item__img-box__inner"]}
            style={{
              borderColor: `transparent ${team_color} transparent  transparent`,
            }}
          >
            <img src={img_src ? img_src : getDefaultImage()} />
          </div>
          {logo_src ? (
            <div className={styles["c-DBlist-item__img-box__team-logo"]}>
              <div
                className={styles["c-DBlist-item__img-box__team-logo__image"]}
              >
                <img src={logo_src} />
              </div>
            </div>
          ) : null}
        </div>
        <div className={styles["c-DBlist-item__text-box"]}>
          <h3 className={styles["c-DBlist-item__text-box__name"]}>
            {name}
            {verified && <VerificationIcon />}
          </h3>
          {tags && tags.length !== 0 ? (
            <div className={styles["c-DBlist-item__text-box__type"]}>
              {isStudent ? "希望職種：" : null}
              {tags.map((tag, i) => (
                <span key={i}>{tag}</span>
              ))}
            </div>
          ) : (
            <div className={styles["c-DBlist-item__text-box__type"]}>
              {isStudent ? "希望職種：未定" : null}
            </div>
          )}
        </div>
      </SonicLink>
    </article>
  );
};

export default DBListItem;
